import React, { useRef, useState } from "react";
import styles from "./AddMaterialDrawer.module.scss";
import { Drawer } from "antd";
import TNButton from "../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
  CommonButtonTexts,
} from "../../../../enums/ButtonAttributesEnums";
import {
  addMaterialFromValidation,
  addNewMaterialValidation,
  DrawerConstants,
  FormFieldNames,
} from "./constants";
import AddMaterialForm from "./AddMaterialForm";
import Form from "../../../Form";
import AddNewMaterialModal from "./AddNewMaterialModal";

interface AddMaterialDrawerProps {
  isOpen: boolean;
  handleCancel: () => void;
  submitActionCall?: () => void;
  quarryId: string;
  isEdit?: boolean;
  materialDetails?: any;
}

const AddMaterialDrawer = ({
  isOpen,
  handleCancel,
  submitActionCall,
  quarryId,
  isEdit = false,
  materialDetails,
}: AddMaterialDrawerProps) => {
  const formRef = useRef<{
    handleSubmitForm?: (
      onValid: SubmitHandler<FieldValues>,
      onInvalid?: SubmitErrorHandler<FieldValues>,
    ) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  }>({});

  const { PLACEMENT, TITLE, WIDTH } = DrawerConstants;
  const [isMaterialModalOpen, setIsMaterialModalOpen] =
    useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<
    string | undefined
  >();
  const [subCategoriesList, setSubCategoriesList] = useState<[]>([]);

  const handleSetMaterialModalOpen = () => setIsMaterialModalOpen(true);
  const handleSetMaterialModalClose = () => setIsMaterialModalOpen(false);

  const handleSubmitButton = async () => {
    if (!!formRef.current) {
      await formRef?.current?.handleSubmitForm();
    }
  };

  const DrawerHeader = <span className={styles.drawerTitle}>{TITLE}</span>;

  const DrawerFooter = (
    <div className={styles.drawerButtons}>
      <TNButton
        text={CommonButtonTexts.CANCEL}
        type={ButtonType.DEFAULT}
        size={ButtonSize.LARGE}
        shape={ButtonShape.DEFAULT}
        onClick={() => {
          handleCancel();
        }}
      />
      <TNButton
        text={CommonButtonTexts.SUBMIT}
        type={ButtonType.PRIMARY}
        size={ButtonSize.LARGE}
        shape={ButtonShape.DEFAULT}
        onClick={() => {
          handleSubmitButton();
        }}
      />
    </div>
  );

  return (
    <Drawer
      visible={isOpen}
      onClose={handleCancel}
      className={styles.addMaterialDrawer}
      maskClosable={false}
      destroyOnClose
      getContainer={false}
      placement={PLACEMENT}
      width={WIDTH}
      title={DrawerHeader}
      footer={DrawerFooter}
    >
      <Form
        validationSchema={
          addMaterialFromValidation
        }
      >
        {() => (
          <>
            <AddMaterialForm
              handleOpenMaterialModal={handleSetMaterialModalOpen}
              isOpen={isOpen}
              quarryId={quarryId}
              handleClose={handleCancel}
              ref={formRef}
              isEdit={isEdit}
              setSubCategoriesList={setSubCategoriesList}
              setSelectedCategory={setSelectedCategory}
              materialDetails={isEdit ? materialDetails : {}}
              priceUnitDefault={materialDetails?.quantityType}
              entryId={isEdit ? materialDetails?.id : undefined}
              materialPictureProp={materialDetails?.materialPicture}
              submitActionCall={submitActionCall}
            />
            <AddNewMaterialModal
              isOpen={isMaterialModalOpen}
              handleClose={handleSetMaterialModalClose}
              subCategoriesList={subCategoriesList}
            />
          </>
        )}
      </Form>
    </Drawer>
  );
};

export default AddMaterialDrawer;
